import DoAPICall from './DoAPICall'

//Create Survey Question
export async function createSurveyQuestion(userToken, SurveyQuestion){
	const apiPayload = {
		httpMethod:'post',
		userToken,
		uri:'surveyquestions',
		payLoad:{
			survey_question_list_type_id:SurveyQuestion.survey_question_list_type_id,
			survey_id:SurveyQuestion.survey_id,
			prompt:SurveyQuestion.prompt,
			order:SurveyQuestion.order,
			type:SurveyQuestion.type,

		},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Get All Survey Question
export async function getSurveyQuestions(userToken,survey_id){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'surveyquestions?survey_id='+survey_id,
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Get One Survey Question
export async function getSurveyQuestion(userToken, id){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'surveyquestions/'+id,
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Update Survey Question
export async function updateSurveyQuestion(userToken, SurveyQuestion){
	const apiPayload = {
		httpMethod:'put',
		userToken,
		uri:'surveyquestions/'+SurveyQuestion.id,
		payLoad:{
			survey_id:SurveyQuestion.survey_id,
			prompt:SurveyQuestion.prompt,
			type:SurveyQuestion.type,
			order:SurveyQuestion.order
		},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Delete Survey Question
export async function deleteSurveyQuestion(userToken, id){
    const apiPayload = {
        httpMethod:'delete',
        userToken,
        uri:'surveyquestions/'+id,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}